// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"19":"blog","40":"debug","75":"mc","472":"settings"}[chunkId] + "-" + {"19":"d2231","40":"af11b","75":"19d06","472":"560b0"}[chunkId] + ".js";
};